import React from 'react';
import { appEnvironment } from 'helpers';

import styles from './GoodbyeScreen.module.scss';

export const GoodbyeScreen = () => {
  const getYear = () => new Date().getFullYear();

  return (
    <div className={styles.container}>
      <header className={styles.site_header}>
        <div className={styles.bin}>
          <a className={styles.logo_container} href="https://nira.com" target="_blank">
            <svg
              className={styles.nira_logo}
              width="69"
              height="30"
              viewBox="0 0 69 30"
              xmlns="http://www.w3.org/2000/svg"
              role="img"
              aria-label="Nira logo"
            >
              <path
                d="M16.537 29.67c.63 0 1.24-.041 1.83-.124.59-.082 1.022-.165 1.296-.248V16.382c0-2.42-.836-4.312-2.51-5.674-1.672-1.361-4.058-2.042-7.157-2.042-1.728 0-3.298.206-4.71.619-1.412.412-2.585.949-3.517 1.61-.549.384-.98.81-1.296 1.278C.158 12.641 0 13.246 0 13.99v12.38c0 .687.09 1.244.267 1.67.179.427.432.764.761 1.012.33.247.734.413 1.214.495.48.083 1.021.124 1.625.124.63 0 1.24-.041 1.83-.124.59-.082 1.022-.165 1.296-.248V14.98a4.09 4.09 0 011.378-.619 6.497 6.497 0 011.625-.206c.823 0 1.474.2 1.954.598.48.4.72 1.025.72 1.878v9.739c0 .687.089 1.244.267 1.67.179.427.432.764.761 1.012.33.247.734.413 1.214.495.48.083 1.021.124 1.625.124zm10.65-22.242c1.151 0 2.077-.358 2.776-1.073.7-.715 1.049-1.596 1.049-2.641s-.35-1.926-1.049-2.641C29.263.358 28.338 0 27.186 0c-1.151 0-2.077.358-2.776 1.073-.7.715-1.05 1.596-1.05 2.64 0 1.046.35 1.927 1.05 2.642.699.715 1.625 1.073 2.776 1.073zm.37 22.242c.603 0 1.2-.048 1.789-.145a79.5 79.5 0 001.337-.227V12.503c0-.687-.09-1.244-.267-1.67a2.381 2.381 0 00-.761-1.012c-.33-.247-.734-.412-1.214-.495a9.646 9.646 0 00-1.625-.124c-.603 0-1.2.048-1.79.145a79.5 79.5 0 00-1.336.227v16.795c0 .687.089 1.244.267 1.67.178.427.432.764.761 1.012.33.247.734.413 1.214.495.48.083 1.021.124 1.625.124zm10.978 0c.631 0 1.241-.041 1.83-.124.59-.082 1.022-.165 1.297-.248V15.227c.356-.165.788-.31 1.296-.433.507-.124 1.048-.241 1.624-.351a19.477 19.477 0 013.538-.33c.165-.303.302-.64.411-1.011.11-.372.165-.75.165-1.135 0-1.155-.384-1.988-1.152-2.497-.768-.509-1.81-.763-3.126-.763-.795 0-1.59.062-2.386.186-.795.124-1.563.295-2.304.516-.74.22-1.433.474-2.077.763-.645.289-1.186.612-1.625.97a3.826 3.826 0 00-1.008 1.217c-.233.454-.35.997-.35 1.63v12.38c0 .687.09 1.244.268 1.67.178.427.432.764.761 1.012.33.247.734.413 1.214.495.48.083 1.021.124 1.624.124zm20.921.33c3.236 0 5.746-.536 7.528-1.61a5.946 5.946 0 001.42-1.175c.397-.454.596-1.039.596-1.754v-9.244c0-1.293-.233-2.414-.7-3.363a6.233 6.233 0 00-1.994-2.352c-.864-.619-1.906-1.08-3.127-1.382-1.22-.303-2.57-.454-4.052-.454-.96 0-1.981.069-3.064.206-1.084.138-2.023.358-2.818.66-.713.303-1.241.667-1.584 1.094-.343.426-.514.997-.514 1.712 0 .55.123 1.08.37 1.59.247.508.549.886.905 1.134a16.14 16.14 0 012.674-.825c.987-.22 2.002-.33 3.044-.33 1.316 0 2.324.171 3.024.515.699.344 1.049.915 1.049 1.713v.289l-5.39.577c-2.358.248-4.1.88-5.224 1.899-1.124 1.017-1.686 2.476-1.686 4.374 0 1.128.226 2.118.679 2.97a5.676 5.676 0 001.933 2.105c.836.55 1.837.963 3.003 1.238 1.165.275 2.475.413 3.928.413zm0-5.117c-1.014 0-1.734-.172-2.16-.516a1.644 1.644 0 01-.637-1.34c0-.551.247-.964.74-1.239.494-.275 1.125-.44 1.893-.495l2.962-.248v3.302c-.275.165-.693.295-1.255.392a9.199 9.199 0 01-1.543.144z"
                fill="#000"
                fillRule="nonzero"
              ></path>
            </svg>
          </a>
        </div>
      </header>

      <main className={styles.binFull}>
        <section className={styles.nira_section__alt}>
          <div className={styles.bin}>
          {appEnvironment === 'chrome' ?  <h1 className={styles.section__title}>
              This free Chrome Extension by Nira is no longer available for use.
            </h1> : <h1>This free application by Nira is no longer available for use.</h1>}
            <p role="doc-subtitle">
              We appreciate you using it and for all your feedback and comments.
              <br />
              If you’re looking for an alternative, you can try using{' '}
              <a href="https://slapdash.com/" target="_blank" rel="noopener">
                Slapdash
              </a>{' '}
              instead.
            </p>

            <h2>Why are we shutting it down?</h2>
            <p>
              We{' '}
              <a
                href="https://twitter.com/hnshah/status/1399773415213436934"
                target="_blank"
                rel="noopener"
              >
                pivoted
              </a>{' '}
              our business to focus on protecting company documents from unauthorized access. If you
              or your company’s Google administrators are looking to protect company documents, we’d
              love to schedule a live demo of Nira.{' '}
              <a href="https://nira.com" target="_blank" rel="noopener">
                Learn more here
              </a>
              .
            </p>

            {appEnvironment === 'chrome' && <p>
              <a href="#"  onClick={() => { chrome.management.uninstallSelf() }}>
                Click here to remove from Chrome.
              </a>
            </p> }
          </div>
        </section>
      </main>

      <footer className={styles.siteFooter}>
        <div className={styles.bin}>
          <div className={styles.copyright}>&copy; {getYear()}, Nira.</div>
          <nav className={styles.siteFooter__menu__alt} aria-label="More information about Nira">
            <ul className={styles.menu_items}>
              <li id="menu-item-4333" className={styles.menu_item}>
                <a href="https://nira.com/about/" target="_blank">About</a>
              </li>
              <li id="menu-item-4332" className={styles.menu_item}>
                <a href="https://nira.com/careers/" target="_blank">Careers</a>
              </li>
              <li id="menu-item-4327" className={styles.menu_item}>
                <a href="https://nira.com/blog/" target="_blank">Blog</a>
              </li>
              <li id="menu-item-4328" className={styles.menu_item}>
                <a href="https://nira.com/terms-of-service/" target="_blank">Terms</a>
              </li>
            </ul>
          </nav>
        </div>
      </footer>
    </div>
  );
};
